import { map } from 'rxjs/operators/map';
import { GroupSerializer } from '../../models';
import ajax from '../../utils/ajax';

class GroupService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/group';
  configurationPathGroup = '/networkAsset/airfinder/groups';

  /**
    Get Groups in a site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  getBySiteId = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(GroupSerializer.normalize)));
  };

  /**
    Create a group
    @param {Object} group
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (group, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: GroupSerializer.serialize(group),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => GroupSerializer.normalize(data.response)));
  };

  /**
    Edit a group
    @param {Object} group
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (group, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${group.id}`,
        body: GroupSerializer.editSerialize(group),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => GroupSerializer.normalize(data.response)));
  };

  /**
    Delete a group
    @param {String} groupId
    @param {Object} store Redux store
    @returns {Observable}
  */
  delete = (groupId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${groupId}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new GroupService();



// WEBPACK FOOTER //
// ./src/services/group/index.js